import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import "./TextArea.css";

function TextArea(props) {
  const [value, setValue] = useState("");
  const [error, setError] = useState();
  const [rows, setRows] = useState(2);
  const label = useRef(null);
  const inputRef = useRef(null);

  // set initial set of rules
  useEffect(() => {
    if (inputRef.current?.clientHeight < inputRef.current?.scrollHeight) {
      setRows(4);
    }
  }, [props.defaultValue]);

  const handleTextInput = (event) => {
    setValue(event.target.value);
    if (typeof props.onChange === "function") {
      props.onChange(event);
    }
    if (
      inputRef.current?.clientHeight < inputRef.current?.scrollHeight &&
      rows < 4
    ) {
      setRows((pervState) => pervState + 1);
    }
  };

  const validators = (value) => {
    let isValidInput = true;

    if (!value || String(value).length === 0) {
      isValidInput = false;
      props.isValidInput?.(isValidInput);
      return;
    }

    const validationResult = props.validation?.(value);

    if (validationResult?.status === false) {
      isValidInput = false;

      if (validationResult?.message !== error) {
        setError(validationResult?.message);
      }
    } else if (error) {
      setError(null);
    }

    props.isValidInput?.(isValidInput);
    inputRef.current?.classList.toggle("error", !isValidInput);
  };

  useEffect(() => {
    validators(value);
    // eslint-disable-next-line
  }, [value, props.validation]);

  return (
    <div className={`inherit-parent-width  ${props.className || ""}`}>
      <div
        className={`position-relative inherit-parent-width display-flex flex-align-items-end ${props.className ||
          ``} ${props.disabled === true ? "background-color-grey" : ""}
        `}
      >
        <div className="flex-center-children-horizontally font-size-medium font-family-gilroy-medium inherit-parent-width">
          <div className="inherit-parent-width">
            <textarea
              data-cy={props["data-cy"]}
              rows={rows}
              ref={inputRef}
              defaultValue={props.defaultValue}
              value={props.value}
              className={`text-area inherit-parent-width font-color-secondary font-family-gilroy-medium font-size-medium text-area-padding display-block min-width-250px border-none text-area-border-bottom-default
                  ${
                    typeof props.buttonName === "string"
                      ? "padding-right-4p7-em"
                      : ""
                  } ${
                props.disabled === true ? "font-color-secondary disabled" : ""
              }
                  `}
              autoComplete={props.autoComplete}
              onFocus={() => {
                if (!props.disabled) {
                  label.current.classList.add("active");
                  inputRef.current.classList.add("active");
                }
              }}
              onBlur={(event) => {
                if (event.target.value.trim().length === 0) {
                  setRows(2);
                  label.current.classList.remove("active");
                }
                inputRef.current.classList.remove("active");
                if (typeof props.onOutOfFocus === "function") {
                  props.onOutOfFocus();
                }
              }}
              type={props.type}
              name={props.name}
              onChange={handleTextInput}
              readOnly={props.disabled}
              required={props.required}
            />
            <span className="text-area-border-bottom" />
            <label
              htmlFor={props.name}
              ref={label}
              className={`  ${
                props.removeResponsive ? "" : "adaptive-font-size"
              } font-color-secondary text-area-label position-absolute font-family-gilroy-medium font-size-medium ${
                inputRef.current === document.activeElement ||
                (props.value
                  ? String(props.value).trim().length !== 0
                  : false) ||
                (props.defaultValue
                  ? String(props.defaultValue).trim().length !== 0
                  : false) ||
                props.alwaysActive
                  ? "active"
                  : ""
              } ${props.labelClassName || ""} ${
                props.disabled === true ? "background-color-grey disabled" : ""
              }`}
              onFocus={() => {
                if (!props.disabled) {
                  label.current.classList.add("active");
                  inputRef.current.classList.add("active");
                }
              }}
            >
              {props.label}
            </label>
          </div>
        </div>
      </div>
      <InputInfo {...props} error={error} />
    </div>
  );
}

const InputInfo = ({ error, notes, inputNotesClassName }) => {
  if (typeof error === "string" && error !== "") {
    return (
      <p className="font-size-smaller padding-top-small font-color-red">
        {error}
      </p>
    );
  } else if (typeof notes === "string") {
    return (
      <p
        className={` ${inputNotesClassName ||
          "font-size-smaller font-color-secondary padding-top-small"} `}
      >
        {notes}
      </p>
    );
  } else {
    return <p className="font-size-smaller">&nbsp;</p>;
  }
};

TextArea.propTypes = {
  /**
   * default value attribute
   */
  defaultValue: PropTypes.string,
  /**
   * callback function for5 onChange event
   */
  onChange: PropTypes.func,
  /**
   * class name for the parent element of the component
   */
  className: PropTypes.string,
  /**
   * defines the disable state
   */
  disabled: PropTypes.bool,
  /**
   * selector attribute for cypress testing
   */
  "data-cy": PropTypes.string,
  /**
   * text area value attribute
   */
  value: PropTypes.string,
  /**
   * autoComplete attribute of text area
   */
  autoComplete: PropTypes.oneOf(["on", "off"]),
  /**
   * content for the button
   */
  buttonName: PropTypes.string,
  /**
   * onBlur event of text area
   */
  onOutOfFocus: PropTypes.func,
  /**
   * type of text area
   */
  type: PropTypes.string,
  /**
   * name attribute for text area
   */
  name: PropTypes.string,
  /**
   * class name for label element
   */
  labelClassName: PropTypes.string,
  /**
   * content for the label element
   */
  label: PropTypes.string,
  /**
   * input required attribute
   */
  required: PropTypes.bool
};

TextArea.defaultProps = {
  defaultValue: undefined,
  onChange: undefined,
  className: "",
  disabled: false,
  "data-cy": "text-area-input",
  value: undefined,
  autoComplete: "off",
  buttonName: null,
  onOutOfFocus: undefined,
  type: "text",
  name: "text-area",
  labelClassName: "",
  label: "",
  required: false
};

export default TextArea;
